import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { useT } from "../lib/i18n";

export default function NotFound() {
  const { t } = useT();
  return (
    <div className="container-x py-24 text-center" data-testid="not-found-page">
      <Seo title={t("notFound.title")} noindex />
      <p className="eyebrow">{t("notFound.eyebrow")}</p>
      <h1 className="text-3xl sm:text-4xl font-extrabold mt-2 mb-4">{t("notFound.title")}</h1>
      <p className="text-slate-700 mb-8">{t("notFound.text")}</p>
      <div className="flex flex-wrap justify-center gap-4">
        <Link to="/" className="bg-amber-700 text-white px-5 py-2.5 rounded-lg font-semibold" data-testid="404-home-link">{t("notFound.home")}</Link>
        <Link to="/sitemap" className="border-2 border-slate-900 px-5 py-2.5 rounded-lg font-semibold" data-testid="404-sitemap-link">{t("notFound.sitemap")}</Link>
      </div>
    </div>
  );
}
